// extracted by mini-css-extract-plugin
export default {"button":"gyxxSs","animatedgradient":"mte2vE"};